import getFileByUid from '@picsart/cloud-storage/api/getFileByUid';

import { ErrorMessages } from '@/consts/errors';
import { getCloudStorageHeaders, withCloudStorageErrorHandling } from './utils';

type Params = {
  uid: string;
};

const getFile = async ({ uid }: Params) => {
  return withCloudStorageErrorHandling(async () => {
    const { response } = await getFileByUid({
      headers: getCloudStorageHeaders(),
      uid,
    });
    return response;
  }, ErrorMessages.driveFile);
};

export { getFile };
